
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.486.5c-.271 0-.378.336-.527.882a10.05 10.05 0 00-.234 1.4v2.473l-1.05.644V5.82a.116.116 0 00.112-.093c.052-.229.086-.462.103-.696a2.302 2.302 0 00-.084-.522.116.116 0 00-.112-.084h-.649c-.047 0-.09.03-.107.074a1.82 1.82 0 00-.051.579 1.98 1.98 0 00.088.667.117.117 0 00.103.075l.061.42L.817 9.012a.119.119 0 00-.056.098v.107L.57 9.6a.11.11 0 000 .051v.201c0 .043.023.082.061.103h.056a.12.12 0 00.065 0l.182-.126 4.723-1.867h.961l.103.387v1.363c0 .271.06.933.06.933l.29 1.96-1.587.98a.468.468 0 00-.285.378l-.042.397a.118.118 0 00.117.131h.033l1.95-.56.056.466a.118.118 0 00.117.103h.121c.06 0 .11-.044.117-.103l.056-.466 1.951.56h.032a.117.117 0 00.117-.131l-.042-.397a.466.466 0 00-.285-.378l-1.586-.98.308-1.927c0-.033.06-.667.06-.957V8.359l.103-.388h.961l4.723 1.867.182.126a.12.12 0 00.065 0h.056a.117.117 0 00.061-.103v-.2a.114.114 0 000-.052l-.191-.382v-.108a.119.119 0 00-.056-.098L9.861 6.249l.061-.42a.116.116 0 00.103-.074c.067-.216.097-.442.088-.668a1.816 1.816 0 00-.051-.578.115.115 0 00-.107-.075h-.649a.116.116 0 00-.112.084c-.048.17-.076.346-.084.523.017.233.051.466.103.695.01.054.057.092.112.093v.08l-1.05-.644c.034-1.289.044-2.712-.234-3.883C7.897.831 7.785.5 7.514.5h-.028z"}})])
          )
        }
      }
    